import PaymentBraintree from 'hb-react/frontoffice/components/payments/PaymentBraintree';
import PaymentPaypal from 'hb-react/frontoffice/components/payments/PaymentPaypal';
import PaymentStripe from 'hb-react/frontoffice/components/payments/PaymentStripe';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import { computeTotalPrice } from 'hb-react/shared/apps/Events/utils/priceAndPayments';
import { displayNotif } from 'hb-react/shared/helpers/notifications';

const Stripe = ({
  values,
  event,
  totalPrice,
  currency,
  routes,
  onPaymentSuccess,
  onPaymentCancel,
}) => (
  <PaymentStripe
    stripeAccountId={event.payment_account_external_account_id}
    title={event.title}
    amount={Math.round(totalPrice * 100)}
    currency={currency}
    userEmail={values?.receipt?.email}
    endpointUrl={routes.event_attendees_path(event.id)}
    endpointData={values}
    onPaymentSuccess={(_response) => {
      onPaymentSuccess();
    }}
    payment_type="NetworkEvents::Event"
    payment_type_id={event.id}
    onPaymentCancel={() => onPaymentCancel()}
    onPaymentError={(error) => {
      onPaymentCancel();
      displayNotif(
        'error',
        error?.response?.data?.errors ||
          I18n.t('web.networks.events.bookings.booking_error'),
      );
    }}
  />
);

const Paypal = ({
  values,
  event,
  totalPrice,
  currency,
  routes,
  onPaymentSuccess,
  onPaymentCancel,
}) => (
  <PaymentPaypal
    commit
    paymentData={values}
    amount={totalPrice}
    currency={currency}
    createOrderUrl={Routes.paypal_create_order_path()}
    executePaymentUrl={routes.event_attendees_path(event.id)}
    payment_type="NetworkEvents::Event"
    payment_type_id={event.id}
    paymentSuccessCallback={({ data }) => onPaymentSuccess(data)}
    cancelCallback={onPaymentCancel}
    failCallback={(error) => {
      onPaymentCancel();
      displayNotif(
        'error',
        error?.response?.data?.errors ||
          I18n.t('web.networks.events.bookings.booking_error'),
      );
    }}
  />
);

const Braintree = ({
  values,
  event,
  totalPrice,
  currency,
  routes,
  onPaymentSuccess,
  onPaymentCancel,
}) => (
  <PaymentBraintree
    displayInModal
    getClientTokenUrl={Routes.braintree_to_charge_path({
      payment_type: 'NetworkEvents::Event',
      payment_type_id: event.id,
    })}
    executePaymentUrl={routes.event_attendees_path(event.id)}
    amount={totalPrice}
    currency={currency}
    additionalData={values}
    closeBraintreeModal={() => onPaymentCancel()}
    successCallback={() => {
      onPaymentSuccess();
    }}
    failCallback={(error) => {
      onPaymentCancel();
      displayNotif(
        'error',
        error?.response?.data?.errors ||
          I18n.t('web.networks.events.bookings.booking_error'),
      );
    }}
  />
);

const PaymentStep = ({ onPaymentSuccess, onPaymentCancel }) => {
  const {
    event,
    config: { routes },
  } = useEventContext();

  const { valuesStep1, valuesStep2, selectedCurrency, getFormData } =
    useRegistrationFlowContext();

  const totalPrice = computeTotalPrice({
    selectedTickets: valuesStep1.tickets,
    availableTickets: event.tickets,
    attendees: valuesStep2.network_events_booking?.attendees_attributes,
    addons: valuesStep2.network_events_booking?.addons_attributes,
    donations: valuesStep2.network_events_booking?.donations_attributes,
  });

  const values = getFormData();

  const paymentParameters = {
    values,
    event,
    totalPrice,
    currency: selectedCurrency,
    routes,
    onPaymentSuccess,
    onPaymentCancel,
  };

  if (event.payment_account_linked && totalPrice) {
    switch (event.payment_gateway) {
      case 'Stripe':
        return <Stripe {...paymentParameters} />;
      case 'Paypal':
        return <Paypal {...paymentParameters} />;
      case 'Braintree':
        return <Braintree {...paymentParameters} />;
      default:
        throw new Error(
          `Unknown payment gateway ${event.get('payment_gateway')}`,
        );
    }
  } else if (!event.payment_account_linked && totalPrice) {
    displayNotif('error', 'No payment account linked to this event');
  } else {
    displayNotif('error', 'Purchasing Free tickets no yet implemented');
  }
  onPaymentCancel();

  return null;
};

export default PaymentStep;
